module.exports = __webpack_public_path__ + "img/header.da9cab9a.png";